import { Stack } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import Actions from "src/components/Actions";
import ApplicationCard from "src/components/cards/Application.Card";
import Loader from "src/components/Loader";
import useApi, { useGET } from "src/hooks/useApi";
import Application from "src/types/Application.type";
import TrackingSystem from "../../../lib/Tracking/TrackingSystem";

export default function RemoveApplication() {
  const navigate = useNavigate();
  const { id } = useParams();
  const api = useApi();

  const url = `res/application/${id}`;
  const { data, isLoading, error } = useGET<Application>(url);

  const handleConfirm = () => {
    api.DELETE(`res/application/${id}`);
      let ts = TrackingSystem.getInstance().sendCustomEvent("application_deleted");

      navigate("/app");
  };
  const handleCancel = () => navigate(-1);

  if (error || (!isLoading && !data)) {
    navigate("/404");
  }
  return (
    <Stack align="center">
      Are you sure to remove this application?
      <Loader isLoading={isLoading} error={error} hasData={!!data}>
        <ApplicationCard application={data} />
      </Loader>
      <Actions
        actions={[
          {
            label: "cancel",
            onClick: handleCancel,
            variant: "default",
          },
          {
            label: "confirm",
            onClick: handleConfirm,
          },
        ]}
      />
    </Stack>
  );
}
